import queryString from 'query-string';
import { getPlaylist, setARPlaylist } from './common/playlist/playlistActions';
import { getStudentResults } from './common/api/resultStudentActions';
import {
    startRetriableGet,
    retriableGetComplete,
    retriableGetFailed,
    networkError,
} from './common/api/apiCallActions';
import { APP_DATA_FETCH_RETRY } from './common/api/apiRetryGetConstants';
import { ALL_PERIODS } from './constants/result';
import selectors from './rootSelectors';
import { LANTERN_ERROR_CODES, BROWSER_ERROR_MESSAGES } from './constants/error';
import {
    setSecureBrowserError,
    setVerifiedAccessKioskError,
} from './common/secureBrowser/secureBrowserActions';

export const fetchApplicationData = () => (dispatch, getStore) => {
    const store = getStore();
    const { period } = queryString.parse(window.location.search);

    if (selectors.getExternalURLSourceStatus(store) && ALL_PERIODS.includes(period)) {
        dispatch(startRetriableGet(APP_DATA_FETCH_RETRY));
        return dispatch(setARPlaylist(period))
            .then(() => dispatch(getStudentResults()))
            .then(() => {
                dispatch(retriableGetComplete(APP_DATA_FETCH_RETRY));
            })
            .catch(error => {
                dispatch(retriableGetFailed(APP_DATA_FETCH_RETRY));
                // Match against known browser-generated network error strings.
                // Only the matched constant — never the raw error.message — is
                // forwarded downstream, so request URLs / payloads / user input
                // possibly attached to the original error never reach logs.
                const errorMessage = (error?.message || '').toLowerCase();
                const matchedBrowserError =
                    (errorMessage.includes(BROWSER_ERROR_MESSAGES.LOAD_FAILED) &&
                        BROWSER_ERROR_MESSAGES.LOAD_FAILED) ||
                    (errorMessage.includes(BROWSER_ERROR_MESSAGES.FAILED_TO_FETCH) &&
                        BROWSER_ERROR_MESSAGES.FAILED_TO_FETCH) ||
                    (errorMessage.includes(BROWSER_ERROR_MESSAGES.APPEARS_OFFLINE) &&
                        BROWSER_ERROR_MESSAGES.APPEARS_OFFLINE);
                if (matchedBrowserError) {
                    dispatch(
                        networkError(
                            'ar-playlist',
                            { method: 'GET' },
                            {
                                message: matchedBrowserError,
                                statusCode: LANTERN_ERROR_CODES.NO_CONNECTION,
                                status: 'NETWORK_ERROR',
                            },
                        ),
                    );
                }
            });
    } else {
        // TODO investigate why nobody waits for this promise and how this situation affects the flow
        dispatch(startRetriableGet(APP_DATA_FETCH_RETRY));
        return dispatch(getPlaylist()).then(
            () => {
                dispatch(retriableGetComplete(APP_DATA_FETCH_RETRY));
            },
            () => {
                dispatch(retriableGetFailed(APP_DATA_FETCH_RETRY));
            },
        );
    }
};

export const showErrorInChromeOSWithoutKiosk = () => dispatch => {
    dispatch(setSecureBrowserError(LANTERN_ERROR_CODES.CHROME_OS_WITHOUT_KIOSK));
};

export const showVerifiedAccessKioskError = () => dispatch => {
    dispatch(setVerifiedAccessKioskError(LANTERN_ERROR_CODES.VERIFIED_ACCESS_KIOSK_ERROR));
};
